<template>
  <div class="pageContol listWrap templateList">
    <div class="framePage">
      <div class="framePage-title">
        <span>
          <em>当前位置：</em>
          <a href="javascript:;" @click="goHerf()">培训管理</a>
          <i>></i>
          <a href="javascript:;" class="cur-a">培训答疑详情</a>
        </span>
      </div>
      <div class="framePage-body">
        <div class="framePage-scroll">
          <div class="ovy-a">
            <Reply
              v-if="listData.length"
              :listData="listData"
              :projectId="projectId"
              :projectCourseId="projectCourseId"
              @testShowName="getListData"
            />
            <Empty v-if="!listData.length" slot="empty" />
          </div>
        </div>
        <!-- <div class="pageNum">
          <el-pagination
            :total="fenYe.total"
            :page-size="fenYe.size"
            :current-page="fenYe.currentPage"
            background
            :page-sizes="[10, 20, 30, 40, 50]"
            layout="total, sizes,prev, pager, next,jumper"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          ></el-pagination>
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
import Empty from "@/components/Empty.vue";
import Reply from "@/views/classListCom/traingReply.vue";
import { resetKeepAlive } from "@/utils/common";
export default {
  name: "evaluate/commentManagementInfo",
  components: {
    Empty,
    Reply,
  },
  data() {
    return {
      projectId: "", //班级id
      projectCourseId: "", //班级课程ID
      projectName: "", // 班级名称
      courseName: "", // 课程名称
      reportNum: "", // 举报次数
      userNum: "", // 用户数量
      listData: [],
      // 分页
      fenYe: {
        currentPage: 1, // 当前页数
        size: 10,
        total: null, // 共多少页
      },
    };
  },
  watch: {},
  created() {
    this.projectId = JSON.parse(this.$route.query.row).projectId;
    this.discussId = JSON.parse(this.$route.query.row).discussId;
    this.projectCourseId = JSON.parse(this.$route.query.row).projectCourseId;
    this.projectName = JSON.parse(this.$route.query.row).projectName;
    this.courseName = JSON.parse(this.$route.query.row).courseName;
    // this.reportNum = JSON.parse(this.$route.query.row).reportNum;
    // this.userNum = JSON.parse(this.$route.query.row).userNum;
    // 初始化获取列表数据
    this.getListData();
    // this.getJbAanCy();
    
  },
  computed: {},
  mounted() {},
  methods: {
  
    // 初始化获取评论列表
    getListData() {
      this.$post("/biz/comp/course/discuss/getInfo", {discussId:this.discussId})
        .then((res) => {
          for (let i = 0; i < res.data.length; i++) {
            res.data[i].show = true;
          }
           this.listData = res.data;
           console.log(this.listData);
        })
        .catch(() => {
          return;
        });
    },
    goHerf(){
       this.$router.push({
        path: "/web/trainingQusetionAnswer",
        query: {
          refresh: true
        }
      });
    }
  },
  beforeRouteLeave: resetKeepAlive,
};
</script>
<style lang="less" scope>
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #5c6be8;
}
.titleNameNumber {
  height: 40px;
  line-height: 40px;
  padding: 0 1rem;
  border-bottom: 1px solid #eee;
  .l {
    float: left;
  }
  .r {
    float: right;
    span {     
      font-size: 16px;
      font-weight: 600;
    }
  }
}
</style>